import React from "react";
import PrivateQuotationCard from "./PrivateQuotationCardUnified.tsx";
import { connect } from "react-redux";
import {
  setPostulationProjectId,
  closeNDAModal,
} from "../../store/actions/index";
import PublicQuotationItem from "./PublicQuotations/PublicQuotationItemCard.tsx";

const QuotationsList = ({
  item,
  userData,
}) => {

  return item.type === "PRIVATE" ? (
   <PrivateQuotationCard
      item={item}
      userData={userData}
      />
  ) : (
      <PublicQuotationItem  item={item} isQuotation />
  );

};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
  };
};

export default
  connect(mapStateToProps, {
    setPostulationProjectId,
    closeNDAModal,
  })(QuotationsList);
